import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Sidebar from './components/sidebar';

// Context Provider
import { SidebarProvider } from './context/SidebarContext';

// Modules
import ProtectedRoute from './components/security/protectedRoute';

// Pages
import Topbar from './pages/header';
import StudentAdminPage from './pages/studentAdmin';
import TutorAdminPage from './pages/tutorAdmin';
import MyStudentsPage from './pages/myStudents';
import Login from './pages/login';
import Home from './pages/dashboard/home';
import NoAccessPage from './pages/noAccess';
import AccountPage from './pages/account/account';
import ForgotPasswordPage from './pages/forgotPassword';
import ResetPasswordPage from './pages/resetPassword';
import SessionsPage from './pages/sessions';
import AssignTutorsPage from './pages/assignTutors';
import ManageDatabasePage from './pages/manageDatabase';
import InfoPage from './pages/info';
import TestProgress from './pages/testing';


// Theme and Colours
// import './css/site.css';
import './index.css';
import '@fontsource/inter';
import { ThemeProvider } from '@mui/material';
import theme from './css/theme';

import Colors from './constants/colors';

const setCSSVariables = (colors, parentKey = '') => {
  Object.keys(colors).forEach((key) => {
    const value = colors[key];
    const cssVariableName = parentKey ? `${parentKey}-${key}` : key;

    if (typeof value === 'object') {
      setCSSVariables(value, cssVariableName);
    } else {
      document.documentElement.style.setProperty(`--${cssVariableName}`, value);
    }
  });
};

setCSSVariables(Colors);

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem('authToken') !== null
  );

  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <ThemeProvider theme={theme}>
        {isLoggedIn && (
          <Topbar isLoggedIn={isLoggedIn} setLoginStatus={setIsLoggedIn} />
        )}
        <div style={{ display: 'flex' }}>
        <SidebarProvider>
          {isLoggedIn && <Sidebar />}
          <div className="content" style={{ flexGrow: 1, padding: '2rem' }}>
            <Routes>
              <Route
                path="/"
                element={
                  <ProtectedRoute setLoginStatus={setIsLoggedIn}>
                    <Home setLoginStatus={setIsLoggedIn} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/myStudents"
                element={
                  <ProtectedRoute setLoginStatus={setIsLoggedIn}>
                    <MyStudentsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/assignTutors"
                element={
                  <ProtectedRoute setLoginStatus={setIsLoggedIn}>
                    <AssignTutorsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/studentAdmin"
                element={
                  <ProtectedRoute setLoginStatus={setIsLoggedIn}>
                    <StudentAdminPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tutorAdmin"
                element={
                  <ProtectedRoute setLoginStatus={setIsLoggedIn}>
                    <TutorAdminPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account"
                element={
                  <ProtectedRoute setLoginStatus={setIsLoggedIn}>
                    <AccountPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sessions"
                element={
                  <ProtectedRoute setLoginStatus={setIsLoggedIn}>
                    <SessionsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/manageDatabase"
                element={
                  <ProtectedRoute setLoginStatus={setIsLoggedIn}>
                    <ManageDatabasePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/info"
                element={
                  <ProtectedRoute setLoginStatus={setIsLoggedIn}>
                    <InfoPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/test" element={<TestProgress />} />
              <Route path="/no-access" element={<NoAccessPage />} />
              <Route
                path="/login"
                element={<Login onLogin={() => setIsLoggedIn(true)} />}
              />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
            </Routes>
          </div>
          </SidebarProvider>
        </div>
      </ThemeProvider>
    </Router>
  );
};

export default App;
